import { FC, useEffect, useRef, useState } from "react";
import { toAbsoluteUrl } from "../helpers";
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import clsx from "clsx";

interface PlaceAutocompleteProps {
  onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
  defaultValue?: any;
  errors?: any;
}

export const PlaceAutocomplete: FC<PlaceAutocompleteProps> = ({
  onPlaceSelect,
  defaultValue = undefined,
  errors = [],
}) => {
  const [inputValue, setInputValue] = useState(defaultValue || "");
  const [placeAutocomplete, setPlaceAutocomplete] =
    useState<google.maps.places.Autocomplete | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const places = useMapsLibrary("places");

  useEffect(() => {
    if (defaultValue) {
      setInputValue(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options = {
      fields: ["geometry", "address_components", "formatted_address"],
      componentRestrictions: { country: "us" },
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener("place_changed", () => {
      const place = placeAutocomplete.getPlace();
      setInputValue(place.formatted_address);
      onPlaceSelect(place);
    });
  }, [onPlaceSelect, placeAutocomplete]);

  return (
    <div className="autocomplete-container mb-3">
      <span>
        <img src={toAbsoluteUrl("images/address-icon.svg")} alt="" />{" "}
      </span>
      <input
        className={clsx(
          "form-control",
          errors?.formatted_address && "is-invalid",
        )}
        ref={inputRef}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      />
      {errors?.formatted_address && (
        <div className="invalid-feedback">{errors?.formatted_address}</div>
      )}
    </div>
  );
};
